export type VoucherConditionApi = {
  conditionType?: string
  operator?: string
  value?: unknown
  isEnable?: boolean
}

export type VoucherApiV3 = {
  voucherId?: string
  voucherCode?: string
  displayName?: string
  voucherCategoryCode?: string
  isEnable?: boolean
  defaultAmount?: number | string
  voucherQuantity?: number | string
  createdDate?: string
  startDate?: string
  endDate?: string
  initMethod?: string
  valueType?: 'AMOUNT' | 'PERCENT' | string
  value?: number | string
  status?: string
  productType?: string
  voucherType?: string
  voucherCodeType?: string
  remainCounter?: number
  remainAmount?: string | number
  conditions?: VoucherConditionApi[]
  clientId?: string
  /** Tiền tố của các mã sinh tự động (vd "TEV001_") — dùng để nhận diện mã thuộc voucher này. */
  prefix?: string
  /** Mã khuyến mãi áp dụng — nguồn duy nhất cho normalize; `voucherCode` chỉ metadata */
  codes?: string[]
}

/**
 * DOP-942 — Cấu hình giảm giá "trừ dần" theo từng hệ thống đặt chỗ (system: 9G, QH, VN, VJ, VU…),
 * đọc ĐỘNG từ điều kiện `SYSTEM_TIERED_DISCOUNT` của voucher (thay cho hard-code % QH/9G).
 * Gate duy nhất là hãng/system (VJ, VU, QH, 9G…) — KHÔNG gate theo hạng ghế.
 * Công thức mỗi system = B + C + A (mỗi phần cộng đúng 1 lần cho mỗi chặng):
 *   B `percentOfBasePrice` % trên giá gốc hãng (vé+thuế+phí hãng, KHÔNG gồm phí hệ thống) — MỌI hạng ghế.
 *     Nếu hạng ghế khớp cabinTier `unitType: "PERCENT"` thì cộng dồn % tier vào B rồi tính MỘT LẦN.
 *   C `domesticFlatAmount` số tiền cố định cho mỗi chặng nội địa × (ADT+CHD) — MỌI hạng ghế
 *   A `cabinTiers` unitType FIXED (mặc định) — số tiền GIẢM THÊM × (ADT+CHD) khi hạng ghế khớp
 */
export type SystemTieredDiscountCabinTierUnitType = "FIXED" | "PERCENT"

export type SystemTieredDiscountCabinTier = {
  /** Tên hạng vé khớp (vd "Economy classic", "Business Prime"); so khớp không phân biệt hoa/thường/space. */
  match: string[]
  /**
   * FIXED (mặc định): số tiền VNĐ GIẢM THÊM khi hạng ghế khớp.
   * PERCENT: % (0–100) trên giá vé chặng khớp hạng đó; cộng dồn với percentOfBasePrice rồi tính một lần.
   */
  amount: number
  /** Mặc định "FIXED" nếu không truyền (config cũ vẫn hợp lệ). */
  unitType?: SystemTieredDiscountCabinTierUnitType
}

export type SystemTieredDiscountEntry = {
  cabinTiers?: SystemTieredDiscountCabinTier[]
  /** Cách nhân phần cố định (A, C); hiện hỗ trợ "PER_LEG_AND_PAX". */
  multiplier?: 'PER_LEG_AND_PAX' | string
  domesticFlatAmount?: number
  percentOfBasePrice?: number
}

/** Map theo mã hệ thống đã chuẩn hoá (bỏ "_" đầu, viết hoa): "9G", "QH", … */
export type SystemTieredDiscountConfig = Record<string, SystemTieredDiscountEntry>

export type ParsedSystemTieredDiscount = {
  systems: SystemTieredDiscountConfig
  /** Các mã cụ thể đã được API trả về (một phần) — khớp chính xác để mở khoá. */
  codes: string[]
  /** Tiền tố mã (vd "TEV001_") — mã người dùng nhập bắt đầu bằng prefix ⇒ thuộc chương trình này. */
  prefixes: string[]
}

export const EMPTY_SYSTEM_TIERED_DISCOUNT: ParsedSystemTieredDiscount = {
  systems: {},
  codes: [],
  prefixes: [],
}

export type VoucherCategoryApiV3 = {
  voucherCategoryCode?: string
  categoryName?: string
  categoryTitle?: string
  categoryType?: string
  initMethod?: string
  clientId?: string
  vouchers?: VoucherApiV3[]
}

export type VouchersGetAllResponseV3 = {
  categories?: VoucherCategoryApiV3[]
}

export type VouchersGetAllBody = {
  /** Redux service layer only — stripped before HTTP; enables JSON.stringify POST */
  TYPE?: 'JSON'
  clientId: string
  includeCodes?: boolean
  codesLimit?: number
  productTypes?: string[]
  markets?: string[]
  voucherTypes?: string[]
}
